import Col from "react-bootstrap/Col";
import {Nav} from "react-bootstrap";
import { Link } from 'react-router-dom';
import React from "react";


function Sidebar(){
    return (
        <Col md={3} lg={2} className="bg-light vh-100">
            <Nav className="flex-column pt-2">
                <Nav.Link as={Link} to="/" style={{ marginRight: '10px' }}>Home</Nav.Link>
                <Nav.Link as={Link} to="/projects" style={{ marginRight: '10px' }}>Projects</Nav.Link>
                <Nav.Link as={Link} to="/system-types" style={{ marginRight: '10px' }}>System Types</Nav.Link>
                <Nav.Link as={Link} to="/environments">Environments</Nav.Link>
            </Nav>
        </Col>
    );
}

export default Sidebar